// import aftersalesReplayList from './list'
const addcategory = {
  path: 'contract/addcategory',
  component: resolve => require(['@/pages/admin/platform/contract/addcategory'], resolve),
  meta: {
    requireAuth: true
  },
  children: [
    // aftersalesReplayList,
  ]
}

export default addcategory
